import { Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
var ProfilePasswordComponent = (function () {
    function ProfilePasswordComponent(apiService, router, translate) {
        this.apiService = apiService;
        this.router = router;
        this.translate = translate;
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.errorMessage = null;
        this.errorMsgForShow = null;
    }
    ProfilePasswordComponent.prototype.checkErrorMsg = function (error) {
        this.errorMsgForShow = this.apiService.getErrorMessage(error);
        if (this.translate.currentLang === 'en') {
            this.errorMessage = this.errorMsgForShow[0];
        }
        else {
            this.errorMessage = this.errorMsgForShow[1];
        }
    };
    ProfilePasswordComponent.prototype.submit = function () {
        var _this = this;
        this.errorMessage = null;
        if (this.newPassword.length == 0)
            this.errorMessage = "โปรดกรอกรหัสผ่าน";
        else if (this.confirmPassword !== this.newPassword)
            this.errorMessage = "รหัสผ่านไม่ตรงกัน";
        else {
            this.apiService.updatePassword({
                old_password: this.oldPassword,
                new_password: this.newPassword
            }).subscribe(function () { return _this.router.navigate(['']); }, function (error) {
                // let message = this.apiService.getErrorMessage(error);
                // this.errorMessage = message
                _this.checkErrorMsg(error);
            });
        }
    };
    return ProfilePasswordComponent;
}());
export { ProfilePasswordComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-password/profile-password.component.ts.pre-build-optimizer.js